import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Qualification from './Qualification';
import { fetchQualifications } from 'store/qualification/qualificationActions';

class QualificationContainer extends React.Component {
    componentDidMount() {
        this.props.fetchQualifications();
    }

    render() {
        const { qualification, isLoading } = this.props;

        return (
            <Qualification
                qualification={qualification}
                isLoading={isLoading}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    qualification: state.qualification.qualifications.items.find(x => x.id === ownProps.qualificationId),
    isLoading: state.qualification.qualifications.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchQualifications: () => dispatch(fetchQualifications(false))
});

QualificationContainer.propTypes = {
    qualificationId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(QualificationContainer);